import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type FaqDTO = {
    question: string;
    answer: string;
    video?:string;
};

type FaqResponse = {
    id:string;
    question: string;
    answer: string;
    video?:string;
    createdAt:string;
    updatedAt:string
} & ApiError;

export const CreateFaq = (data: FaqDTO[]): Promise<FaqResponse> => {
    return axios.post("/faq/create", data)
        .then(response => response.data as FaqResponse);
};
